export const INICIA_TRAMITE_TIMELINE_TAG = 'iniciatramite';
export const CALIFICACION_HIPOTECARIA_TIMELINE_TAG = 'calificacionhipotecaria';
export const PROPUESTA_PERSONALIZADA_TIMELINE_TAG = 'propuestapersonalizadacredito';
